export default "__VITE_ASSET__Bg3OtfAd__"